import {connect} from 'react-redux';
import {actions} from '../../actions/actions';
import {Layout} from '../layout';

export const AppContainer = connect(
  ///TODO: map number of coffees to props
	function mapStateToProps(state) {
		return {
			authenticated: state.authReducer.authenticated,
      online: state.onlineReducer.online,
      total: state.coffeeReducer.coffees,
      user: state.authReducer.user,
			coffeeTotal: state.statsReducer.coffeeTotal,
			coffeesThisHour: state.statsReducer.coffeesThisHour,
			memberTotal: state.statsReducer.memberTotal,
			membersThisHour: state.statsReducer.membersThisHour
		};
	},
  function mapDispatchToProps(dispatch){
    return{
      signOut: ()=>{

        dispatch( actions.logOut() );
      },
      action: ()=>{
        console.log("drink a coffee!")
        dispatch( actions.drink() );
      }
    }
  }
)(Layout);



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/containers/appContainer.js